import styled from 'styled-components';
import { colors } from '../../theme';

export type IState = 'standby' | 'ready' | 'good' | 'finished';

const bgMap = {
    standby: 'blue',
    ready: 'red',
    good: 'green',
    finished: 'blue',
}

const getBackound = (state: IState) => {
    switch(bgMap[state]) {
        case 'blue':
            return colors.blue;
        case 'red':
            return colors.red;
        case 'green':
            return colors.green;
    }
    return colors.blue;
};

export const FinishedBox = styled.div`
    width: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;

export const ReactionTimeBox = styled.div<{ state: IState }>`
    background: ${props => getBackound(props.state)};
    display: flex;
    flex: 1;
    height: 300px;
    justify-content: center;
    align-items: center;
`;

export const MainInfoBox = styled.div`
    color: #fff;
    text-align: center;
    display: flex;
    flex-direction: column;
    font-size: 23px;
`;